import { Tag } from './contacts';

export interface EntityList<T> {
  items: T[];
  totalCount: number;
}

export interface PaginatedResponse<T> {
  items: T[];
  page: number;
  limit: number;
  totalCount: number;
}

export interface Captcha {
  captcha: string;
}

export enum ChipsType {
  branch,
  tag,
  rank,
  location
}

export interface ChipsFilter {
  id: string;
  name: string;
  type?: ChipsType;
}

export interface PaginationState {
  page: number;
  limit: number;
}

export interface TagView {
  id: string;
  name: string;
}

export type DateType = number | string | Date | null | undefined;

export interface DateFilter {
  dateFrom?: DateType;
  dateTo?: DateType;
}

export interface MenuItems {
  title: string;
  path: string;
  logo?: JSX.Element;
  tags?: Tag[];
}

export interface MenuCategory {
  id: string;
  name: string;
  slug: string;
  tags: Tag[];
}

export interface RoutItem {
  path: string;
  relativePath: string;
  title: string;
}
